import {
    getAddressData,
    saveCountry,
    saveState,
    saveDistrict,
    saveCity,
    editCountry,
    editState,
    editDistrict,
    editCity,
    deleteCountry,
    deleteState,
    deleteDistrict,
    deleteCity,
    servicesAvailable,
    saveAddressServices,
    getAddressServices,
} from "@/http/setup/addressMaster";

export default {
    namespaced: true,
    state: {
        addressData: [],
        availableServices: [],
        addressService: []
    },
    actions: {
        async fetchAddressData({ commit },) {
            const resp = await getAddressData();
            commit('SET_ADDRESS_DATA', resp.data.pageItems);
            return resp;
        },
        async saveCountryAction({ commit }, payload) {
            const resp = await saveCountry(payload);
            return resp;
        },
        async saveStateAction({ commit }, payload) {
            const resp = await saveState(payload);
            return resp;
        },
        async saveDistrictAction({ commit }, payload) {
            const resp = await saveDistrict(payload);
            return resp;
        },
        async saveCityAction({ commit }, payload) {
            const resp = await saveCity(payload);
            return resp;
        },
        async editCountryAction({ commit }, payload) {
            const resp = await editCountry(payload.id, payload.data);
            return resp;
        },
        async editStateAction({ commit }, payload) {
            const resp = await editState(payload.id, payload.data);
            return resp;
        },
        async editDistrictAction({ commit }, payload) {
            const resp = await editDistrict(payload.id, payload.data);
            return resp;
        },
        async editCityAction({ commit }, payload) {
            const resp = await editCity(payload.id, payload.data);
            return resp;
        },
        async deleteCountryAction({ commit }, id) {
            const resp = await deleteCountry(id);
            return resp;
        },
        async deleteStateAction({ commit }, id) {
            const resp = await deleteState(id);
            return resp;
        },
        async deleteDistrictAction({ commit }, id) {
            const resp = await deleteDistrict(id);
            return resp;
        },
        async deleteCityAction({ commit }, id) {
            const resp = await deleteCity(id);
            return resp;
        },
        async serviceAvailableAction({ commit },) {
            const resp = await servicesAvailable();
            commit('SET_SERVICES', resp.data.pageItems);
            return resp;
        },
        async saveServiceAction({ commit }, payload) {
            const resp = await saveAddressServices(payload.id, payload.data);
            return resp;
        },
        async fetchAddressServices({ commit }, payload) {
            const resp = await getAddressServices(payload.id, payload.type);
            commit('SET_ADDRESS_SERVICES', resp.data);
            return resp;
        },
    },
    mutations: {
        ['SET_ADDRESS_DATA'](state, payload) {
            Object.assign(state, { addressData: payload });
        },
        ['SET_SERVICES'](state, payload) {
            Object.assign(state, { availableServices: payload });
        },
        ['SET_ADDRESS_SERVICES'](state, payload) {
            Object.assign(state, { addressService: payload });
        },

    },
};
